var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembers = function SvgMembers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 20V18.2222C15.6 17.2792 15.2207 16.3749 14.5456 15.7081C13.8705 15.0413 12.9548 14.6667 12 14.6667H6.6C5.64522 14.6667 4.72955 15.0413 4.05442 15.7081C3.37928 16.3749 3 17.2792 3 18.2222V20M15.6 4.11378C16.372 4.31144 17.0557 4.75668 17.5437 5.37961C18.0318 6.00254 18.2966 6.7679 18.2966 7.55556C18.2966 8.34321 18.0318 9.10857 17.5437 9.7315C17.0557 10.3544 16.372 10.7997 15.6 10.9973M21 20V18.2222C20.9994 17.4344 20.7339 16.6691 20.2452 16.0465C19.7565 15.4239 19.0723 14.9792 18.3 14.7822M12.9 7.55556C12.9 9.51923 11.2882 11.1111 9.3 11.1111C7.31177 11.1111 5.7 9.51923 5.7 7.55556C5.7 5.59188 7.31177 4 9.3 4C11.2882 4 12.9 5.59188 12.9 7.55556Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "members.b6b0e86154676f8eb29b82b73cb55bcc.svg";